import { useCallback, useMemo } from "react";
import { FormattedData, dataFormatUtilsWithLanguage, } from "@nexthink/data-formatter";
/**
 * This hook is a wrapper around the data-formatter library.
 * If no locale is provided, the browser's default locale will be used.
 */
const useFormatter = (formatterType, options) => {
    const formatter = useMemo(() => dataFormatUtilsWithLanguage.getFormatter(formatterType), [formatterType]);
    return useCallback((value, overrideOptions) => {
        return formatter.format(value, Object.assign(Object.assign({}, options), overrideOptions)).map((v) => v, (e) => (Object.assign({ error: e.message }, new FormattedData(value, value, ""))));
    }, [formatter, options && Object.entries(options).flat()]);
};
export default useFormatter;
//# sourceMappingURL=useFormatter.js.map